import {
	Container,
	ContainerGutter,
	ContainerPadding,
	CTA,
	Text,
	TokenTextAppearance,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import styled from 'styled-components';
import { BenefitsHelper } from '../../../../../../helpers/benefits-helper';
import { useHuchaPopup } from '../../../shared/hooks/use-hucha-popup';
import { HuchaPosventaValues } from '../../../shared/models/hucha-values';
import { useHuchaPosventaLayerContent } from '../../hooks/use-hucha-posventa-layer-content';

const StatusIndicator = styled.div<{ status: string }>`
	background: ${(props: { status: string }) => props.status};
	border: 1px solid white;
	border-radius: 50%;
	width: 16px;
	height: 16px;
`;

export const BonoPosventaButtonAndStatus = ({ huchaValues }: { huchaValues: HuchaPosventaValues }) => {
	const { huchaPosventaPopupLayerContent } = useHuchaPosventaLayerContent(huchaValues);
	const { handlePopupOpen } = useHuchaPopup({ huchaValues, layerContent: () => huchaPosventaPopupLayerContent });

	return (
		<>
			<Container
				wrap="always"
				stretchContent
				verticalAlign="center"
				horizontalAlign="center"
				gutter={ContainerGutter.static300}
			>
				<CTA tag="button" emphasis="primary" onClick={handlePopupOpen}>
					Aprovéchalo
				</CTA>
				<Container wrap={'never'} gutter={ContainerGutter.static100} verticalAlign={'center'} shrinkContent>
					<Container
						padding={{
							right: ContainerPadding.static100,
						}}
					>
						<StatusIndicator status={BenefitsHelper.getHuchaBonusStatusColor(huchaValues.expirationDate)} />
					</Container>

					<Text appearance={TokenTextAppearance.copy200} color={TokenTextColor.primary}>
						{BenefitsHelper.getHuchaBonusValidityMessage(huchaValues.expirationDate)}
					</Text>
				</Container>
			</Container>
		</>
	);
};
